import React from 'react';
import './InfoPage.css';

function Careers() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Carreiras na Nukki</h1>

        <section className="info-section">
          <h2>Junte-se a nós na criação de um mundo onde qualquer pessoa possa pertencer a qualquer lugar</h2>
          <p>Na Nukki, estamos construindo uma plataforma que conecta milhões de pessoas ao redor do mundo. Junte-se à nossa equipe de indivíduos apaixonados e criativos que estão moldando o futuro das viagens e da hospitalidade.</p>
        </section>

        <section className="info-section">
          <h3>Por que Trabalhar na Nukki?</h3>

          <div className="feature-grid">
            <div className="feature-box">
              <h4>🚀 Impacto em Escala</h4>
              <p>Seu trabalho impactará milhões de pessoas em todo o mundo. Construa produtos e experiências que fazem uma diferença real em como as pessoas viajam e se conectam.</p>
            </div>
            <div className="feature-box">
              <h4>🌟 Crescimento e Aprendizado</h4>
              <p>Oportunidades contínuas de aprendizado, programas de mentoria e suporte para seu desenvolvimento profissional.</p>
            </div>
            <div className="feature-box">
              <h4>🌍 Cultura Global</h4>
              <p>Trabalhe com pessoas talentosas de diversas origens ao redor do globo. Experimente diferentes perspectivas e culturas.</p>
            </div>
            <div className="feature-box">
              <h4>💡 Inovação em Primeiro Lugar</h4>
              <p>Incentivamos o pensamento criativo e a tomada de riscos inteligentes. Suas ideias podem se tornar realidade aqui.</p>
            </div>
            <div className="feature-box">
              <h4>⚖️ Equilíbrio entre Vida e Trabalho</h4>
              <p>Arranjos de trabalho flexíveis, folgas generosas e uma cultura que valoriza seu bem-estar.</p>
            </div>
            <div className="feature-box">
              <h4>🎁 Ótimos Benefícios</h4>
              <p>Remuneração competitiva, cobertura de saúde abrangente, participação acionária e vantagens exclusivas de viagem.</p>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Nossos Benefícios</h3>

          <div className="help-topic">
            <h4>Saúde e Bem-estar</h4>
            <ul>
              <li>Cobertura médica, odontológica e oftalmológica abrangente</li>
              <li>Suporte e aconselhamento de saúde mental</li>
              <li>Programas de bem-estar e academias</li>
              <li>Licença parental para todos os pais</li>
            </ul>
          </div>

          <div className="help-topic">
            <h4>Benefícios Financeiros</h4>
            <ul>
              <li>Pacotes salariais competitivos</li>
              <li>Participação acionária para todos os funcionários</li>
              <li>Plano de aposentadoria com contrapartida da empresa</li>
              <li>Bônus anuais de desempenho</li>
            </ul>
          </div>

          <div className="help-topic">
            <h4>Viagem e Experiência</h4>
            <ul>
              <li>Crédito anual de viagem para usar na Nukki</li>
              <li>Encontros e retiros trimestrais da equipe</li>
              <li>Programas de intercâmbio entre funcionários</li>
              <li>Explore comunidades locais onde operamos</li>
            </ul>
          </div>

          <div className="help-topic">
            <h4>Desenvolvimento Profissional</h4>
            <ul>
              <li>Orçamento para aprendizado e desenvolvimento</li>
              <li>Suporte para participação em conferências</li>
              <li>Programas de treinamento interno</li>
              <li>Oportunidades de mentoria</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Vagas Abertas</h3>

          <div className="job-listing">
            <h4>Engenheiro de Software Sênior - Plataforma</h4>
            <div className="job-meta">Engenharia • São Francisco, CA / Remoto</div>
            <p>Construa sistemas escaláveis que alimentam nosso mercado global. Trabalhe com tecnologias de ponta para resolver desafios complexos.</p>
          </div>

          <div className="job-listing">
            <h4>Designer de Produto - Experiência do Anfitrião</h4>
            <div className="job-meta">Design • Nova York, NY / Remoto</div>
            <p>Projete experiências intuitivas que ajudam anfitriões a terem sucesso. Molde as ferramentas e interfaces usadas por milhões de anfitriões em todo o mundo.</p>
          </div>

          <div className="job-listing">
            <h4>Cientista de Dados - Busca e Descoberta</h4>
            <div className="job-meta">Ciência de Dados • Seattle, WA / Remoto</div>
            <p>Use aprendizado de máquina para melhorar como os hóspedes descobrem sua estadia perfeita. Construa sistemas de recomendação em escala massiva.</p>
          </div>

          <div className="job-listing">
            <h4>Especialista em Experiência do Cliente</h4>
            <div className="job-meta">Suporte • Austin, TX / Remoto</div>
            <p>Seja a voz da Nukki para nossa comunidade. Ajude hóspedes e anfitriões a terem experiências excepcionais.</p>
          </div>

          <div className="job-listing">
            <h4>Gerente de Marketing - Crescimento</h4>
            <div className="job-meta">Marketing • Los Angeles, CA / Remoto</div>
            <p>Impulsione a aquisição e o engajamento de usuários através de campanhas criativas. Expanda nossos esforços de marketing global.</p>
          </div>

          <div className="job-listing">
            <h4>Líder de Operações de Confiança e Segurança</h4>
            <div className="job-meta">Operações • Portland, OR / Remoto</div>
            <p>Mantenha nossa comunidade segura. Construa e expanda programas que mantêm a confiança em toda a nossa plataforma.</p>
          </div>
        </section>

        <section className="info-section">
          <h3>Nossas Equipes</h3>
          <ul>
            <li><strong>Engenharia:</strong> Backend, Frontend, Mobile, Infraestrutura, Segurança</li>
            <li><strong>Produto:</strong> Gerenciamento de Produto, Design de Produto, Pesquisa de Usuário</li>
            <li><strong>Dados:</strong> Ciência de Dados, Analytics, Business Intelligence</li>
            <li><strong>Confiança e Segurança:</strong> Suporte Comunitário, Operações de Risco, Políticas</li>
            <li><strong>Marketing:</strong> Crescimento, Marca, Conteúdo, Comunicações</li>
            <li><strong>Operações:</strong> Atendimento ao Cliente, Suporte ao Anfitrião, Pagamentos</li>
            <li><strong>Negócios:</strong> Finanças, Jurídico, Operações de Pessoas, Recrutamento</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Nosso Processo de Contratação</h3>
          <ol>
            <li><strong>Inscrição:</strong> Envie seu currículo e nos conte por que você está animado com a Nukki</li>
            <li><strong>Triagem do Recrutador:</strong> Ligação de 30 minutos para discutir seu histórico e a função</li>
            <li><strong>Entrevista com o Gerente de Contratação:</strong> Análise aprofundada de sua experiência e das necessidades da nossa equipe</li>
            <li><strong>Avaliação Técnica/de Habilidades:</strong> Avaliação específica da função de suas habilidades</li>
            <li><strong>Entrevistas com a Equipe:</strong> Conheça colegas em potencial e aprenda sobre nossa cultura</li>
            <li><strong>Entrevista Final:</strong> Discussão com a liderança sênior</li>
            <li><strong>Oferta:</strong> Bem-vindo à Nukki!</li>
          </ol>
          <p>Nos esforçamos para concluir o processo em 2 a 3 semanas e mantê-lo informado a cada passo do caminho.</p>
        </section>

        <section className="info-section">
          <h3>Diversidade e Inclusão</h3>
          <p>Estamos comprometidos em construir uma equipe diversificada que reflita as comunidades que atendemos. Acreditamos que a diversidade impulsiona a inovação e cria melhores produtos.</p>
          <ul>
            <li>Empregador de oportunidades iguais</li>
            <li>Grupos de recursos para funcionários de comunidades sub-representadas</li>
            <li>Práticas de contratação inclusivas e treinamento sobre preconceito inconsciente</li>
            <li>Equidade salarial em todas as funções e níveis</li>
            <li>Suporte para diversos caminhos e origens de carreira</li>
          </ul>
        </section>

        <div className="cta-section">
          <h3>Pronto para Causar Impacto?</h3>
          <p>Explore nossas vagas abertas e junte-se a nós na construção do futuro das viagens</p>
          <button className="btn-white">Ver Todas as Vagas</button>
        </div>
      </div>
    </div>
  );
}

export default Careers;
